import React from 'react';
import PropTypes from 'prop-types';

const PushNotification = ({ color, width, height, ariaLabel }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    aria-labelledby="title"
  >
    <title id="title">{ariaLabel}</title>
    <g fill="none" fillRule="evenodd">
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19 9L19 21 0 21 0 3 13 3"
        transform="translate(1 1)"
      />
      <path
        fill={color}
        d="M18.075 0c-1.919 0-3.5 1.56-3.5 3.5 0 1.919 1.56 3.5 3.5 3.5 1.919 0 3.5-1.56 3.5-3.5s-1.56-3.5-3.5-3.5z"
        transform="translate(1 1)"
      />
    </g>
  </svg>
);

PushNotification.defaultProps = {
  ariaLabel: '',
};

PushNotification.propTypes = {
  ariaLabel: PropTypes.string,
  color: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

export default PushNotification;
